import {
  postJsMessage,
  registerSpecificNotificationHandler,
  unregisterSpecificNotificationHandler,
} from '../../bridge';
import API from '../../api';
import { NotificationHandler } from '../../types';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from 'types/index';
import { mobileUI } from './ui';

export type SafeArea = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.getSafeArea
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.5.0+
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function getSafeArea(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<SafeArea>> {
  return isAvailable('mobile.getSafeArea').then(() => {
    return postJsMessage(API.getSafeArea, {}, options);
  });
}

const SafeAreaNotification = ['UnifyNotify_OnSafeAreaChange'];

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.onSafeAreaChange
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.5.0+
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------
 */
export function onSafeAreaChange(
  onSafeAreaChangeCallback: NotificationHandler<
    NativeAPIResponseMessage<SafeArea>
  >
) {
  registerSpecificNotificationHandler(
    SafeAreaNotification,
    onSafeAreaChangeCallback
  );
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.offSafeAreaChange
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.5.0+
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------
 */
export function offSafeAreaChange(
  onSafeAreaChangeCallback: NotificationHandler<
    NativeAPIResponseMessage<SafeArea>
  >
) {
  unregisterSpecificNotificationHandler(
    SafeAreaNotification,
    onSafeAreaChangeCallback
  );
}
export default {
  getSafeArea,
  onSafeAreaChange,
  offSafeAreaChange,
  ...mobileUI,
};
